exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".flexBox__editInner-module___3h-s7 {\n  width: 100%;\n}\n\n.buttonVehicleInfo__editInner-module___26Ia0 {\n    margin-top: 24px;\n}\n\n@media (max-width: 375px) {\n  .flexBox__editInner-module___3h-s7 {\n    min-width: 260px;\n  }\n}\n\n@media (min-width: 769px) {\n  .flexBox__editInner-module___3h-s7 {\n    min-width: 1570px;\n  }\n}\n", ""]);

// Exports
exports.locals = {
	"flexBox": "flexBox__editInner-module___3h-s7",
	"buttonVehicleInfo": "buttonVehicleInfo__editInner-module___26Ia0"
};